import gCard from "@/components/g-card/g-card.vue"
import gForm from "@/components/g-form/g-form.vue"
import gButton from "@/components/g-button/g-button.vue"
import gSteps from "@/components/g-steps/g-steps.vue"
import CartaPropostaController from "@/shared/controllers/cartaProposta/CartaPropostaController"
import {mask} from 'vue-the-mask'


export default {
  name: 'GerarCartaPropostaMarkup',
  directives: {mask},
  components: {
    'g-card': gCard,
    'g-form': gForm,
    'g-button': gButton,
    'g-steps': gSteps,

  },
  data() {
    return {
      
      quantidadeSelecionada: 0,
      orcamentoModels: {},
      valorReal: 0,
      comissao: 0,
      valorRealInicial: 0,
      comissaoInicial: 0,
      popup: false,
      popupAviso: false,
      popupSemPreco: false,
      popupComissaoZerada: false,
      flagPrazoAutorizado: false,
      flagPrecoAutorizado: false,
      authpreco: '',
      authprazo: '',
      AutorizacaoPrecoString: '',
      AutorizacaoPrazoString: '',
      Baseauthpreco: [],
      Baseauthprazo: [],
      forcedReload: 0,
      salvaObservacaoGeralFront: '',
      salvaObservacaoProdutoFront: '',
      salvaObservacaoCreditoFront: '',
      salvaObservacaoNegUnica: '',


      OrcamentoId: null,
      OrcamentoComponenteId: null,
      CartaPropostaId: null,
      FormaDePagamento: '',
      negociacaoUnica: false,
      Quantidade: 0,
      ValorPrecoIdeal: 0,
      NomeComponente: '',


      linhaviabilidade: "ROLAND 805",
      viabilidadeviabilidade: "SIM",
      products: [
        { "id": "1000", "caixas": "30.000", "folhas": "7.500" },
        { "id": "2000", "caixas": "30.000", "folhas": "7.500" }
      ],

      //icones e cores Viabilidade
      viabilidade: 'Viável',
      iconeviabilidade: "pi pi-check-circle", //pi-times-circle
      coriconeviabilidade: "#00ff00",

      //icone e cores botões observação
      iconeobservacaogeral: "pi pi-check-circle",
      coriconeobservacaogeral: "green",
      iconeobservacaocredito: "pi pi-plus-circle",
      coriconeobservacaocredito: "#fbc02d",
      iconeobservacaoproduto: "pi pi-plus-circle",
      coriconeobservacaoproduto: "#fbc02d",
      iconeobservacaocondicaoespecial: "pi pi-plus-circle",
      coriconeobservacaocondicaoespecial: "#fbc02d",
      CorBotaoAutorizacaoPreco: "white",

      condicaoPagamento: '20',

      formaPagamentoTodos: 0,

      valorIdealPrimeiro: [],

      valorRealModels: [],
      comissaoModels: [],

      //vfor orcamento e componentes
      orcamento: [],

      numerocartaproposta: 0,

      orcamentoProdutoReferencia: {},
      situacaoCartaProposta: 0,
      pt3: false,
      OrcamentosOBSArray: [],
      objetoObservacaoGeral: '',
      objetoObservacaoProduto: '',
      objetoObservacaoCredito: '',
      statusSolicitacao: 0,
      desabilitaBotaoVoltarPagamento: false,
      comissaoMinima: 0,
      comissaoMaxima:0,
      InfosViabilidade: [],
      imagemEmpresa: '',
      desabilitaFinalizar : false
    }
  },
  created() {
  },
  mounted() {
    this.popularMarkup()
    this.GetParametrosComissao()
    // this.adicionarobservacaoproduto()
    this.ImagemEmpresa()
  },

  methods: {
    focusItensMarkup(){
      this.desabilitaFinalizar = !this.desabilitaFinalizar
    },
    VerificaSolicitacaoPrazoAutorizada(){

      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + (`SolicitacaoAutorizacao/VerificaSolicitacaoPrazoAutorizada/${this.$route.params.id}`),
      })
      .then((response) => {
        this.$isLoading(false)
          this.TemSolicitacaoAutorizada = response.data.data.status;

        })
        .catch(() => {
        })

    },
    ImagemEmpresa(){
      CartaPropostaController.GetNomeEmpresaByCartaId(this.$route.params.id).requisicao
      .then((response) => {
        this.NomeEmpresa=response.data.message

        const nomeEmpresa = () => {
          if(this.NomeEmpresa.includes('SUPREMA')) return 'SUPREMA';
          if(this.NomeEmpresa.includes('NORDESTE')) return 'NORDESTE';
          return 'JAUENSE'
        }

        const urlBase = window.location.host
        this.imagemEmpresa =  `http://${urlBase}/repositorio/${nomeEmpresa()}/LOGOTIPO.png`;
      })
    },
    GetParametrosComissao() {
      CartaPropostaController.GetParametrosComissao().requisicao
      .then(response => {
        this.comissaoMinima = response.data.data.comissaoMinima;
        this.comissaoMaxima = response.data.data.comissaoMaxima
      })
      .catch(() => this.$isLoading(false))
    },
    zeraResultado(comissaoEPreco) {
      comissaoEPreco.comissao = 0.000
      comissaoEPreco.valorPrecoReal = 0.000
    },
    VoltarStep2() {
      this.$router.push(`/gerar-carta-proposta/${this.$route.params.id}/pagamento`)
    },
    ObsevacaoGeral() {
      this.pt1 = true
      this.popup = true
      this.adicionarobservacaogeral()
    },
    PopUpFinalizacao() {
      // trazer numero carta proposta
      this.$isLoading(false)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `CartaProposta/GetNumeroCartaProposta/${this.CartaPropostaId}`,
      })
        .then((response) => {
          this.numerocartaproposta = response.data.data
          this.pt1 = false
          this.pt2 = true
          this.popup = true
        })
        .catch(() => {
        });
    },

    CodigoExternoCartaProposta (){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `CartaProposta/GetNumeroCartaProposta/${this.CartaPropostaId}`,
      })
        .then((response) => {
          this.numerocartaproposta = response.data.message
          this.pt1 = false
          this.pt2 = true
          this.popup = true
          this.$isLoading(false)
        })
        .catch(() => {
          this.$isLoading(false)
        });
    },
    PopUpViabilidade(quantidadeSelecionada) {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `CartaProposta/GetInfosViabilidade/${quantidadeSelecionada.id}`,
      })
        .then((response) => {
          this.pt1 = false
          this.pt2 = false
          this.pt3 = true
          this.popup = true
          this.InfosViabilidade = response.data.data

        })
        .catch(() => {
        });

    },
    ObservacaoCredito() {
      this.pt1 = false
      this.pt2 = false
      this.pt3 = false
      this.pt4 = false
      this.pt5 = false
      this.pt6 = true
      this.popup = true
      this.adicionarobservacaocredito()
    },
    ObservacaoProduto() {
      this.pt1 = false
      this.pt2 = false
      this.pt3 = false
      this.pt4 = false
      this.pt5 = false
      this.pt6 = false
      this.pt7 = true
      this.popup = true
      this.adicionarobservacaoproduto()
    },
    PopUpNegociacaoUnica() {
      this.pt1 = false
      this.pt2 = false
      this.pt3 = false
      this.pt4 = false
      this.pt5 = false
      this.pt6 = false
      this.pt7 = false
      this.pt8 = true
      this.popup = true
    },
    PopUppPrazo(orcamento) {
      //procura no banco se ja tem registro de autorização pra esse cara, se tiver ele traz, se não ele só continua
      //salvo aqui a informacao no orcamento,.string se tiver



      let dataParaOBack = {
        orcamentoId: orcamento.orcamentoId,
        autorizacaoPrecoString: orcamento.autorizacaoPrecoString,
        autorizacaoPrazoString: orcamento.autorizacaoPrazoString,
        EhAutorizacaoPreco: false
      }
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `SolicitacaoAutorizacao/GetSolicitacaoAutorizacaoExistente`,
        data: dataParaOBack
      })
        .then((response) => {

          orcamento.autorizaprazo = true

          orcamento.autorizacaoPrazoString = response.data.data.autorizacaoPrazoString
          
        })
        .catch(() => {
        });


    },
    PopUppPreco(orcamento) {
      //procura no banco se ja tem registro de autorização pra esse cara, se tiver ele traz, se não ele só continua
      let dataParaOBack = {
        orcamentoId: orcamento.orcamentoId,
        autorizacaoPrecoString: orcamento.autorizacaoPrecoString,
        autorizacaoPrazoString: orcamento.autorizacaoPrazoString,
        EhAutorizacaoPreco: true
      }
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `SolicitacaoAutorizacao/GetSolicitacaoAutorizacaoExistente`,
        data: dataParaOBack
      })
      .then((response) => {
          orcamento.autorizapreco = true
          orcamento.autorizacaoPrecoString = response.data.data.autorizacaoPrecoString

          
        })
        .catch(() => {
        });
    },
    
    LimparAutorizacaoPreco(orcamento){
      orcamento.autorizacaoPrecoString = null
    },

    LimparAutorizacaoPrazo(orcamento){
      orcamento.autorizacaoPrazoString = null
    },

    fechapopupAuthPreco(orcamento) {
      let dataParaOBack = {
        orcamentoId: orcamento.orcamentoId,
        autorizacaoPrecoString: orcamento.autorizacaoPrecoString,
        autorizacaoPrazoString: orcamento.autorizacaoPrazoString,
        EhAutorizacaoPreco: true
      }
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `SolicitacaoAutorizacao/GetSolicitacaoAutorizacaoExistente`,
        data: dataParaOBack
      })
        .then((response) => {
          if (response.data.data == null)
          {
            orcamento.autorizacaoPrecoString = null
          }
          else {
            orcamento.autorizacaoPrecoString =  response.data.data.autorizacaoPrecoString
          }

          orcamento.autorizapreco = false
          this.pt5 = false
        })
        .catch(() => {
        });

    },

    fechapopupAuthPrazo(orcamento) {

      let dataParaOBack = {
        orcamentoId: orcamento.orcamentoId,
        autorizacaoPrecoString: orcamento.autorizacaoPrecoString,
        autorizacaoPrazoString: orcamento.autorizacaoPrazoString,
        EhAutorizacaoPreco: false
      }
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `SolicitacaoAutorizacao/GetSolicitacaoAutorizacaoExistente`,
        data: dataParaOBack
      })
        .then((response) => {

          if (response.data.data == null)
          {
            orcamento.autorizacaoPrazoString = null
          }
          else {
            orcamento.autorizacaoPrazoString =  response.data.data.autorizacaoPrazoString
          }
          
          this.pt4 = false
          orcamento.autorizaprazo = false
        })
        .catch(() => {
        });

    },

    adicionaautorizacaopreco(orcamento) { //verificar o bloqueio dos campos quando ativado a autorizacao
      orcamento.flagPrecoAutorizado = true
      orcamento.autorizapreco = false
      let dataParaOBack = {
        orcamentoId: orcamento.orcamentoId,
        autorizacaoPrecoString: orcamento.autorizacaoPrecoString,
        autorizacaoPrazoString: orcamento.autorizacaoPrazoString,
        EhAutorizacaoPreco: true
      }
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `SolicitacaoAutorizacao/InsereSolicitacaoAutorizacao`,
        data: dataParaOBack
      })
        .then(() => {
          this.$toast.add({ severity: 'success', summary: 'SUCESSO', detail: 'Autorização de preço enviada com sucesso', life: 7000 })

        })
        .catch(() => {
        });
    },
    adicionarautorizacaoprazo(orcamento) {

      if(orcamento.autorizacaoPrazoString == "" || orcamento.autorizacaoPrazoString == null || orcamento.autorizacaoPrazoString == " ")
      {
        this.$toast.add({ severity: 'warn', summary: 'AVISO', detail: 'Necessário Adicionar uma Observação', life: 7000 })
        orcamento.autorizacaoPrazoString = null
        return
      }

      orcamento.flagPrazoAutorizado = true
      orcamento.autorizaprazo = false

      let dataParaOBack = {
        orcamentoId: orcamento.orcamentoId,
        autorizacaoPrecoString: orcamento.autorizacaoPrecoString,
        autorizacaoPrazoString: orcamento.autorizacaoPrazoString,
        EhAutorizacaoPreco: false
      }
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `SolicitacaoAutorizacao/InsereSolicitacaoAutorizacao`,
        data: dataParaOBack
      })
        .then(() => {
          this.$toast.add({ severity: 'success', summary: 'SUCESSO', detail: 'Autorização de prazo enviada com sucesso', life: 7000 })

        })
        .catch(() => {
        });


    },

    cancelaAutPreco(orcamento) {
      orcamento.flagPrecoAutorizado = false
      orcamento.autorizacaoPrecoString = null

    },
    cancelaAutPrazo(orcamento) {
      orcamento.flagPrazoAutorizado = false
      orcamento.autorizacaoPrazoString = null

    },

    paginafinalizada() {
      this.$router.push(`/gerar-carta-proposta-finalizado/${this.$route.params.id}`)
    },
    salvandoFrontOBSGERAL() {
      this.salvaObservacaoGeralFront = this.objetoObservacaoGeral
      this.pt1 = false;
      this.popup = false;
    },
    zeraOBSGERAL() {
      this.pt1 = false;
      this.popup = false;
      this.objetoObservacaoGeral = ''
      this.salvaObservacaoGeralFront = ''
    },
    salvandoFrontOBSPRODUTO() {
      this.salvaObservacaoProdutoFront = this.objetoObservacaoProduto
      this.popup = false;
      this.pt7 = false;
    },
    zeraOBSPRODUTO() {
      this.popup = false;
      this.pt7 = false;
      this.objetoObservacaoProduto = ''
      this.salvaObservacaoProdutoFront = ''
    },
    salvandoFrontOBSCREDITO() {
      this.salvaObservacaoCreditoFront = this.objetoObservacaoCredito
      this.popup = false;
      this.pt7 = false;
    },
    zeraOBSCREDITO() {
      this.popup = false;
      this.pt7 = false;
      this.objetoObservacaoCredito = ''
      this.salvaObservacaoCreditoFront = ''
    },    
    popularMarkup() {
      this.$isLoading(true)
      this.CartaPropostaId = this.$route.params.id
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `CartaProposta/GetMarkup/${this.CartaPropostaId}`,
      })
        .then((response) => {
          //await new Promise(r => setTimeout(r, 2000));
          this.orcamento = response.data.data;
          this.orcamentoModels = response.data.data;
          this.situacaoCartaProposta = response.data.data[0].situacaoCartaProposta
          this.statusSolicitacao = response.data.data[0].statusSolicitacao
          
          this.calculaPrecoEspecial();

          this.$isLoading(false)
          //se a cartaproposta ja ta digitada ou ta aguardando aprovacao e tem status de aprovada
          // if ((this.situacaoCartaProposta == 1 || this.situacaoCartaProposta == 2) && (this.statusSolicitacao == 1 || this.statusSolicitacao == null)) {
          //   this.$router.push(`/gerar-carta-proposta-inicio`)

          // }
          // else {
            if (response.data.data[0].autorizaPrecoBool == true && response.data.data[0].autorizaPrazoBool == true) {
              this.desabilitaBotaoVoltarPagamento = false
            }
            else if (response.data.data[0].autorizaPrecoBool == true) {
              this.desabilitaBotaoVoltarPagamento = true
            // }

            
          }
          this.formaPagamentoTodos = response.data.data[0].orcamentoProduto.formaDePagamento
          this.negociacaoUnica = response.data.data[0].negociacaoUnica
          this.$isLoading(false)
        })
        .catch(() => {
        });
    },


    async calculaPrecoEspecial(){
      this.orcamentoModels.forEach(x => {
        x.orcamentoProduto.orcamentoQuantidade.forEach(o => {
          if(o.valorPrecoEspecial != 0){
            this.PegaComissaoEspecial(o)
          }
        })
      })
    },

    PegaComissaoEspecial(comissaoEPreco) {
      //se o valor inicial for igual o valor preco especial eu trago a comissao do preco especial caso seja maior que a minima

      //se ele tiver um preco autorizado maior que o ideal 5%, eu deixo o mínimo como o ideal
      if ( comissaoEPreco.valorPrecoEspecial >= comissaoEPreco.valorPrecoIdeal ) {

        this.axios({
          method: 'post',
          url: process.env.VUE_APP_WEB_API + `CartaProposta/GetValorMinimo/${comissaoEPreco.valorPrecoEspecial}`,
          data: comissaoEPreco.valorPrecoEspecial
        })
          .then((res) => {     
            comissaoEPreco.valorPrecoIdealInferior = res.data.data

          })
          .catch(() => {
          });

        // comissaoEPreco.valorPrecoIdealInferior = comissaoEPreco.valorPrecoIdeal - 0.0001
        comissaoEPreco.valorPrecoReal = 0.0000
      }

      if ( comissaoEPreco.valorPrecoEspecial < comissaoEPreco.valorPrecoIdeal ) {
        this.axios({
          method: 'post',
          url: process.env.VUE_APP_WEB_API + `CartaProposta/GetValorMinimo/${comissaoEPreco.valorPrecoEspecial}`,
        })
          .then((res) => { 
            comissaoEPreco.valorPrecoIdealInferior = res.data.data
          })
          .catch(() => {
          });
        // comissaoEPreco.valorPrecoIdealInferior = comissaoEPreco.valorPrecoEspecial - 0.0001
        comissaoEPreco.valorPrecoReal = 0.0000
      }
      
      // if (comissaoEPreco.valorPrecoReal == comissaoEPreco.valorPrecoEspecial) {
      //   comissaoEPreco.valorPrecoIdealInferior = comissaoEPreco.valorPrecoEspecial
      //   comissaoEPreco.valorPrecoReal = 0.0000
      // }

    },
    CalculaValorReal(comissaoEPreco) {
      if (comissaoEPreco.comissao > this.comissaoMaxima && this.flagPrecoAutorizado == false) {
        this.$toast.add({ severity: 'warn', summary: 'Faça uma solicitação de preço', detail: `Comissão não permitida acima que ${this.comissaoMaxima}%`, life: 7000 })
        comissaoEPreco.comissao = 0.00
        comissaoEPreco.valorPrecoReal = 0.0000
      }
      else
        if (comissaoEPreco.comissao < this.comissaoMinima && this.flagPrecoAutorizado == false && comissaoEPreco.valorPrecoEspecial == 0) {
          this.$toast.add({ severity: 'warn', summary: 'Faça uma solicitação de preço', detail: `Comissão não permitida abaixo que ${this.comissaoMinima}%`, life: 7000 })
          comissaoEPreco.comissao = 0.00
          comissaoEPreco.valorPrecoReal = 0.0000
        }
        else
        if (comissaoEPreco.valorPrecoEspecial != 0 && comissaoEPreco.comissao < comissaoEPreco.porcentagemComissaoEspecial) {
          this.$toast.add({ severity: 'warn', summary: 'Faça uma solicitação de preço', detail: `Comissão não permitida abaixo que ${comissaoEPreco.porcentagemComissaoEspecial}%`, life: 7000 })
          comissaoEPreco.comissao = 0.00
          comissaoEPreco.valorPrecoReal = 0.0000
        }


        else {
          this.axios({
            method: 'post',
            url: process.env.VUE_APP_WEB_API + `CartaProposta/CalculaMarkup`,
            data: {
              IsPreco: false,
              Valor: comissaoEPreco.comissao,
              OrcamentoQuantidadeId: comissaoEPreco.id,
              CartaPropostaId: this.$route.params.id
            }
          })
            .then((response) => {
          
              if (!response.data.data)
              {
                this.$toast.add({ severity: 'warn', summary: 'AVISO', detail: 'Comissão não encontrada. Impossível calcular o preço!', life: 7000 })
                comissaoEPreco.comissao = 0.00
              }
              else {
               comissaoEPreco.valorPrecoReal = response.data.data
              
               let numeroString = comissaoEPreco.comissao.toString();
               var valorSemZeros = this.removeZero(numeroString);
               comissaoEPreco.comissao = valorSemZeros
 
               let decimalPlaces = comissaoEPreco.comissao.toString().split('.');
               if (decimalPlaces.length === 1) {
                 decimalPlaces.push("0");
                 decimalPlaces = decimalPlaces[1] || 0;
               }
           
               else if(decimalPlaces != 0) {
                 decimalPlaces = comissaoEPreco.comissao.toString().split('.')[1].length || 0;
               }
               if(decimalPlaces == 1) {
                 comissaoEPreco.comissao = comissaoEPreco.comissao + '0'
               }
               numeroString = comissaoEPreco.comissao.toString();
               var ponto = this.possuiPonto(numeroString);
               if(decimalPlaces == 0 && ponto == false) {
                 comissaoEPreco.comissao = comissaoEPreco.comissao + '.00'
               }
              }
            })
            .catch(() => {
            });
        }
    },
    CalculaComissao(comissaoEPreco) {
      comissaoEPreco.valorPrecoReal = comissaoEPreco.valorPrecoReal.replace(/,/g, ".")

      if (comissaoEPreco.valorPrecoReal < comissaoEPreco.valorPrecoIdealInferior || comissaoEPreco.valorPrecoReal > comissaoEPreco.valorPrecoIdealSuperior) {
        this.$toast.add({ severity: 'warn', summary: 'AVISO', detail: 'É necessario solicitar uma autorização de preço', life: 7000 })
        comissaoEPreco.comissao = 0.000
        comissaoEPreco.valorPrecoReal = 0.000
      }
      else {
        this.axios({
          method: 'post',
          url: process.env.VUE_APP_WEB_API + `CartaProposta/CalculaMarkup`,
          data: {
            IsPreco: true,
            Valor: comissaoEPreco.valorPrecoReal.replace(/,/g, "."),
            OrcamentoQuantidadeId: comissaoEPreco.id,
            CartaPropostaId: this.$route.params.id
          }
        })
          .then((response) => {
            /*eslint-disable*/
            debugger
            if (response.data.data == null)
            {
              comissaoEPreco.comissao = 0.00

            }
            if (response.data.data < this.comissaoMinima && comissaoEPreco.valorPrecoEspecial == 0)
            {

              if(response.data.data == 0)
              {
                comissaoEPreco.comissao = 0.00

                if(comissaoEPreco.valorPrecoReal < comissaoEPreco.valorPrecoIdeal)
                {
                  this.$toast.add({ severity: 'warn', summary: 'Preço Ideal é o mínimo', detail: `Preço digitado abaixo do preço ideal não permitido`, life: 7000 })
                  comissaoEPreco.valorPrecoReal = comissaoEPreco.valorPrecoIdeal
                }
              }
              else{
                this.$toast.add({ severity: 'warn', summary: 'Faça uma solicitação de preço', detail: `Comissão não permitida abaixo de ${this.comissaoMinima}%`, life: 7000 })
                comissaoEPreco.comissao = 0.00
                comissaoEPreco.valorPrecoReal = 0.0000

              }
            }
            else
            if(comissaoEPreco.valorPrecoEspecial != 0 && response.data.data < comissaoEPreco.porcentagemComissaoEspecial)
            {
              // this.$toast.add({ severity: 'warn', summary: 'Faça uma solicitação de preço', detail: `Comissão não permitida abaixo que ${comissaoEPreco.porcentagemComissaoEspecial}%`, life: 7000 })
              comissaoEPreco.comissao = comissaoEPreco.porcentagemComissaoEspecial

            }
            else {
              comissaoEPreco.comissao = response.data.data


              let numeroString = comissaoEPreco.valorPrecoReal.toString();
              var valorSemZeros = this.removeZero(numeroString);
              comissaoEPreco.valorPrecoReal = valorSemZeros

              let decimalPlaces = comissaoEPreco.valorPrecoReal.toString().split('.');
              if (decimalPlaces.length === 1) {
                decimalPlaces.push("0");
                decimalPlaces = decimalPlaces[1] || 0;
              }
          
              else if(decimalPlaces != 0) {
                decimalPlaces = comissaoEPreco.valorPrecoReal.toString().split('.')[1].length || 0;
              }
              if(decimalPlaces == 3) {
                comissaoEPreco.valorPrecoReal = comissaoEPreco.valorPrecoReal + '0'
              }
              if(decimalPlaces == 2) {
                comissaoEPreco.valorPrecoReal = comissaoEPreco.valorPrecoReal + '00'
              }
              if(decimalPlaces == 1) {
                comissaoEPreco.valorPrecoReal = comissaoEPreco.valorPrecoReal + '000'
              }
              numeroString = comissaoEPreco.valorPrecoReal.toString();
              var ponto = this.possuiPonto(numeroString);
              if(decimalPlaces == 0 && ponto == false) {
                comissaoEPreco.valorPrecoReal = comissaoEPreco.valorPrecoReal + '.0000'
              }

            }

          })
          .catch((Error) => {
            this.$toast.add({ severity: 'warn', summary: 'Erro ao fazer cálculo', detail: Error.response.data.message, life: 7000 })
            comissaoEPreco.comissao = 0.00
            comissaoEPreco.valorPrecoReal = 0.0000
            console.error(Error);
          });
      }
    },
    possuiPonto(texto) {
      return texto.includes(".");
    },
    removeZero(number) {
      return parseFloat(number.replace(/^0+/, ''));
    },
    SalvarMarkup() {

      this.$isLoading(true)
      let dataParaOBack = {
        ObservacaoGeral: this.objetoObservacaoGeral,
        ObservacaoProduto: this.salvaObservacaoProdutoFront,
        ObservacaoCredito: this.salvaObservacaoCreditoFront,
        ObservacaoNegociacaoUnica: this.salvaObservacaoNegUnica,
        Orcamentos: this.orcamentoModels,
        CartaPropostaId: this.CartaPropostaId,
        AutorizacaoPreco: this.flagPrecoAutorizado,
        AutorizacaoPrazo: this.flagPrazoAutorizado,
        AutorizacaoPrecoString: this.AutorizacaoPrecoString,
        AutorizacaoPrazoString: this.AutorizacaoPrazoString
      }
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `CartaProposta/PostCartaPropostaOrcamentoFinal/${this.CartaPropostaId}`,
        data: dataParaOBack
      })
        .then((response) => {
          if (response.data.data == "TemAutorizacao") {
            this.popupAviso = true
            this.$isLoading(false)
            return
          }
          if (response.data.data == "SemPreco") {
            this.popupSemPreco = true
            this.$isLoading(false)
            return
          }
          else{
            //CHAMAR AQUI VALIDAÇÃO PRA VER SE REALMENTE SALVOU A COMISSAO, SE NAO SALVOU EU TRAVO E MANTENHO NA TELA PRO USUARIO DIGITAR DNV

            this.VerificaComissaoZerada()

              // this.AtualizaEnumCartaProposta() //aqui ele pega o id do cartaproposta e atualiza o enum dependendo se tem autorização ou não
          }
        })
        .catch(() => {
        });
      },

      VerificaComissaoZerada() {
      
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `CartaProposta/VerificaComissaoZerada/${this.CartaPropostaId}`,
      })
        .then((response) => {

          if (response.data.data == true) {
            this.popupComissaoZerada = true
            this.$isLoading(false)
            return
          }
          this.$isLoading(false)
          // this.AtualizaEnumCartaProposta() //aqui ele pega o id do cartaproposta e atualiza o enum dependendo se tem autorização ou não
              this.CodigoExternoCartaProposta() //aqui traz o numero do cartaproposta que tá no banco pro popup
        })
        .catch(() => {
        });
      },


    SalvarSolicitacaoAutorizacao() {
      this.$isLoading(true)
      let dataParaOBack = {
        Orcamentos: this.orcamentoModels,
        AutorizacaoPreco: this.flagPrecoAutorizado,
        AutorizacaoPrazo: this.flagPrazoAutorizado,
        AutorizacaoPrecoString: this.AutorizacaoPrecoString,
        AutorizacaoPrazoString: this.AutorizacaoPrazoString
      }
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `CartaProposta/SalvarSolicitacaoAutorizacaoMarkup/${this.CartaPropostaId}`,
        data: dataParaOBack
      })
        .then(() => {
          // this.AtualizaEnumCartaProposta() //aqui ele pega o id do cartaproposta e atualiza o enum dependendo se tem autorização ou não
          this.PopUpFinalizacao() //aqui traz o numero do cartaproposta que tá no banco pro popup
        })
        .catch(() => {
        });
      },

    camponumero($event) { // funcao para campo quantidade aceite apenas numero
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        $event.preventDefault();
      }
    },
    // verificarLinhaPreco (id) {
    //   var verificar =  this.Baseauthpreco.find((Element) => Element == id)
    //   if(verificar === undefined) return false
    //    return verificar.length > 0 ? true : false
    // },
    // verificarLinhaPrazo (id) {
    //   var verificar =  this.Baseauthprazo.find((Element) => Element == id)
    //   if(verificar === undefined) return false
    //     return verificar.length > 0 ? true : false
    // },
    AtualizaEnumCartaProposta() {

      let dataParaOBack = {
        Orcamentos: this.orcamentoModels,
        AutorizacaoPreco: this.flagPrecoAutorizado,
        AutorizacaoPrazo: this.flagPrazoAutorizado,
        CartaPropostaId: this.CartaPropostaId
      }

      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `CartaProposta/UpdateStatusCartaProposta`,
        data: dataParaOBack
      })
        .then(() => {
          // this.numerocartaproposta = response.data.data
          // this.pt1 = false
          // this.pt2 = true
          // this.popup=true
        })
        .catch(() => {
        });

    },
    voltar() {
      this.popupSemPreco = false;
      this.popupAviso = false;
    },

  },

}